import { z } from "zod";

export const GetAudioCourseEpisodeSampleSchema = z
  .object({
    audioCourseId: z.string().min(1),
    includeUrl: z.enum(["true", "false"]).optional().default("false"),
    includeMetadata: z.enum(["true", "false"]).optional().default("true"),
  })
  .refine((data) => data.includeUrl === "true" || data.includeMetadata === "true", {
    message: "At least one of includeUrl or includeMetadata must be true",
  });

export type GetAudioCourseEpisodeSampleQueryParams = z.infer<typeof GetAudioCourseEpisodeSampleSchema>;

export interface GetAudioCourseEpisodeSampleResponse {
  // Only included if includeMetadata is true
  courseImage?: string;
  courseName?: string;
  lessonName?: string;
  duration?: number;
  authorName?: string;
  audioCourseId?: string;

  // Only included if includeUrl is true
  url?: string;
}
